import React from 'react';

/**
 * Workflow Diagram Component
 *
 * Horizontal visualization of the LRB platform workflow.
 * Shows the automated pipeline from Meet to Teach.
 */

// Icon components for workflow steps
const WorkflowIcons = {
  video: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="23 7 16 12 23 17 23 7" />
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
    </svg>
  ),
  sync: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
  link: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  document: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
    </svg>
  ),
  whiteboard: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
      <path d="M6 8l4 4-4 4" />
      <line x1="12" y1="12" x2="18" y2="12" />
    </svg>
  )
};

const WorkflowDiagram = ({ steps = [] }) => {
  // Default workflow if no steps provided
  const defaultSteps = [
    { id: 'meet', label: 'Meet', icon: 'video', description: 'Google Meet session' },
    { id: 'sync', label: 'Sync', icon: 'sync', description: 'Transcript extraction' },
    { id: 'link', label: 'Link', icon: 'link', description: 'Student profile match' },
    { id: 'summary', label: 'Summarize', icon: 'document', description: 'AI summary generation' },
    { id: 'plan', label: 'Plan', icon: 'calendar', description: 'Lesson planning' },
    { id: 'teach', label: 'Teach', icon: 'whiteboard', description: 'AI-assisted tutoring' }
  ];

  const workflowSteps = steps.length > 0 ? steps : defaultSteps;

  return (
    <div className="workflow-diagram">
      <div className="workflow-diagram__steps">
        {workflowSteps.map((step, index) => {
          const IconComponent = WorkflowIcons[step.icon] || WorkflowIcons.document;

          return (
            <div
              key={step.id}
              className="workflow-step"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="workflow-step__icon">
                {IconComponent}
              </div>
              <span className="workflow-step__label">{step.label}</span>
              <span className="workflow-step__desc">{step.description}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WorkflowDiagram;
